import { useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function NewsletterSignup({ className = '', onSuccess }) {
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('submitting');
    setErrorMsg('');
    try {
      const res = await fetch(`${API_BASE}/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, fullName: fullName}),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.error?.message || 'Something went wrong');
      setStatus('success');
      setEmail('');
      setFullName('');
      onSuccess?.();
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message);
    }
  };

  if (status === 'success') {
    return (
      <div className={className}>
        <p className="text-sm font-semibold text-emerald-600 flex items-center gap-2">
          <span className="material-symbols-outlined text-[18px]">check_circle</span>
          You're subscribed — we'll email you about new openings.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="flex flex-col md:flex-row gap-2">
        <input
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          placeholder="Your name (optional)"
          className="flex-1 px-4 py-3 rounded-lg border border-[#c4c6d1] outline-none focus:ring-2 focus:ring-[#00255a]/10 text-sm bg-white"
        />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          className="flex-1 px-4 py-3 rounded-lg border border-[#c4c6d1] outline-none focus:ring-2 focus:ring-[#00255a]/10 text-sm bg-white"
        />  
      </div>
      <br />
      <button
          type="submit"
          disabled={status === 'submitting'}
          className="px-6 py-3 text-white font-semibold rounded-lg whitespace-nowrap disabled:opacity-60"
          style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
        >
          {status === 'submitting' ? 'Subscribing...' : 'Subscribe'}
        </button>
      {status === 'error' && <p className="text-sm text-red-600 mt-2">{errorMsg}</p>}
      <p className="text-xs text-[#64748b] mt-2">Get notified when new study and job openings go live.</p>
    </form>
  );
}